//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { useCaseMixin } from '@/apps/attributes/mixins/use_case_mixin';
import tasks from '@/js/tasks';
export default {
  name: 'RegisterFilterComponent',
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  mixins: [useCaseMixin],
  data: function data() {
    return {
      valid: true,
      table: null,
      items: [],
      column: null,
      period: false,
      view_columns: []
    };
  },
  created: function created() {
    this.getTablesViewsList();
  },
  methods: {
    getTablesViewsList: function getTablesViewsList() {
      var _this = this;
      UseCasesService.getSandboxItemsAux(this.item.company_code, this.item.id).then(function (response) {
        var sandboxItems = response.data.sbx_items;
        var views = sandboxItems.VIEW;
        _this.items = views.filter(function (item) {
          return item.labels.origin && item.labels.origin === 'external';
        });
      });
    },
    onSelectView: function onSelectView(event) {
      this.column = null;
      this.period = false;
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    onSubmit: function onSubmit(event) {
      var _this2 = this;
      event.preventDefault();
      if (!this.validate()) {
        return;
      }
      var params = {
        company_name: this.item.company_name,
        applicant: this.userEmail,
        partyid_match: {
          table_id: this.table.table_id,
          column: this.table.party_id,
          period_column: this.period ? this.column : null
        },
        solicitude_type_id: 3
      };
      console.log(params, 'params');
      UseCasesService.matchPartyId(this.item.company_code, this.item.id, params).then(function (response) {
        console.log(response);
        tasks.toast.success(_this2.translate('success_messages.general'), _this2.translate('titles.success'));
      }).catch(function (err) {
        console.log(err);
        tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
      }).finally(function () {
        _this2.$emit('close');
      });
    },
    onPeriodChange: function onPeriodChange() {
      var _this3 = this;
      if (this.period) {
        UseCasesService.ListUseCaseViewColumns(this.item.id).then(function (response) {
          var views_and_columns = response.data.records;
          _this3.view_columns = views_and_columns[_this3.table.view_id];
        });
      }
    }
  },
  computed: {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('descripcion.register_filter'),
        disabled: true
      }];
    },
    rules: function rules() {
      var _this4 = this;
      return {
        base: [function (v) {
          return !!v || _this4.translate('reglas.field');
        }],
        column: [function (v) {
          return !!v || _this4.translate('reglas.field');
        }]
      };
    }
  }
};